// src/sectors/pilates/settings/tabs/NotificationsSettingsTab.jsx
// ✅ Bu tab artık SADECE EMAIL ayarlarıdır.
import React from 'react';
import Chip from '@mui/material/Chip';
import MDBox from 'components/MDBox';
import { TabActions } from '../ui/SettingsUi';

import { pilatesSettingsApi as companySettingsApi } from '../pilatesSettingsApi';

import {
  setByPathEnsure,
  extractEmailSettingsFromCompanySettings,
  normalizeEmailSettings,
} from './notifications/notificationsEmailUtils';

import { EmailAutomationsSection } from './notifications/EmailAutomationsSection';

export function NotificationsSettingsTab() {
  const [loading, setLoading] = React.useState(true);
  const [err, setErr] = React.useState(null);

  const [me, setMe] = React.useState(null);
  const [draft, setDraft] = React.useState({});
  const [snapshot, setSnapshot] = React.useState(''); // dirty compare
  const [saving, setSaving] = React.useState(false);

  const dirty = React.useMemo(() => {
    try {
      return JSON.stringify(draft) !== snapshot;
    } catch {
      return true;
    }
  }, [draft, snapshot]);

  const load = React.useCallback(async () => {
    setLoading(true);
    setErr(null);
    try {
      const res = await companySettingsApi.getMy();
      setMe(res);

      const emailDraft = extractEmailSettingsFromCompanySettings(res);
      setDraft(emailDraft);
      setSnapshot(JSON.stringify(emailDraft));
    } catch (e) {
      console.error(e);
      setErr('Bildirim ayarları yüklenemedi.');
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  const patch = (path, value) => {
    setDraft((prev) => {
      const next = structuredClone(prev);
      setByPathEnsure(next, path, value);
      return next;
    });
  };

  const onReset = () => {
    try {
      setDraft(JSON.parse(snapshot || '{}'));
    } catch {
      setDraft({});
    }
  };

  const onSave = async () => {
    if (!me || saving || !dirty) return;

    setSaving(true);
    setErr(null);

    try {
      const safeDraft = normalizeEmailSettings(draft);
      await companySettingsApi.updateMyEmailNotifications(safeDraft);

      const fresh = await companySettingsApi.getMy();
      setMe(fresh);

      const freshDraft = extractEmailSettingsFromCompanySettings(fresh);
      setDraft(freshDraft);
      setSnapshot(JSON.stringify(freshDraft));
    } catch (e) {
      console.error(e);
      setErr('Bildirim ayarları kaydedilemedi.');
    } finally {
      setSaving(false);
    }
  };

  const badge = (
    <Chip
      size="small"
      variant="outlined"
      label={dirty ? 'Değişiklik var' : 'Kaydedildi'}
      sx={{ borderRadius: '999px', fontWeight: 900 }}
    />
  );

  return (
    <MDBox sx={{ display: 'grid', gap: 1.5 }}>
      {err ? (
        <MDBox sx={{ display: 'flex', justifyContent: 'center', px: 1 }}>
          <Chip
            size="small"
            color="error"
            variant="outlined"
            label={err}
            sx={{ borderRadius: '999px', fontWeight: 900 }}
          />
        </MDBox>
      ) : null}

      {/* ✅ ORTALAYAN WRAPPER */}
      <MDBox
        sx={{
          width: '100%',
          maxWidth: 1020,
          mx: 'auto',
          px: { xs: 1, md: 0 },
          opacity: loading ? 0.6 : 1,
          pointerEvents: loading ? 'none' : 'auto',
          display: 'grid',
          gap: 1.5,
        }}
      >
        <EmailAutomationsSection draft={draft} patch={patch} dirtyBadge={badge} />
        <TabActions saving={saving} dirty={dirty} onReset={onReset} onSave={onSave} />
      </MDBox>
    </MDBox>
  );
}
